import { apiPostWToken } from "../../api/apiPost";
import { ConfAccount } from "../../context/account/paramsAccount";
import { Token } from "../../context/connexion/token/token";
import { User } from "../../context/connexion/userConnext";


export function hookApi(
    url: string,
    data: object,
    conf: any,
    setConf: any,
    setChangeValue: any,
    showError: any
) {
    return new Promise<any>((resolve, reject) => {
        if (conf?.conf?.ifOffLineMode !== true || conf?.conf?.ifOffLineMode === undefined) {
            apiPostWToken(url, data, conf.token, conf, setConf, showError)
                .then((response: any) => {
                    if (!response?.message) {
                        setChangeValue(response)
                        resolve(response);
                    } else {
                        showError(response?.message)
                        resolve(response);
                    }
                })
                .catch(error => {
                    reject(error);  // Rejeter la promesse en cas d'erreur
                });
        }
        else {
        }
    });
}
